import React from "react";
import { appShareTextString, checkMobile } from "./Utils/helper";

const NativeShare = ({ id, children, folderName, togglePopup }) => {
  let quote = folderName;
  let shareUrl1 = `https://www.narendramodi.in/photo-gallery/${id}`;

  const handleNativeShare = async () => {
    let data = {
      title: "",
      url: "",
    };

    try {
      if (navigator && navigator.canShare && navigator.canShare(data)) {
        data["url"] = shareUrl1;
        data["text"] = quote;

        navigator
          .share(data)
          .then(() => {
            console.log("Successfully native shared data");
          })
          .catch((error) => {
            console.log("Error native sharing", error);
          });
      }
    } catch (error) {
      console.error("Error handling native share:", error);
    }
  };

  const handleShare = async (e) => {
    e.preventDefault();
    try {
      let obj = {};
      window.gtag("event", "Share", obj);
    } catch (error) {
      console.error("Error tracking share event:", error);
    }

    try {
      const isMobile = checkMobile() === "mobile";
      if (!isMobile) {
        togglePopup(id, folderName); // Pass id and folderName to togglePopup
      } else if (window.location.href.includes("appversionios")) {
        let sharelink = `appshare://?text=${encodeURIComponent(
          appShareTextString(quote + "  " + shareUrl1)
        )}`;
        window.location.href = sharelink;
      } else if (window.location.href.includes("appversionandroid")) {
        let sharelink = `appshare://text=${encodeURIComponent(
          appShareTextString(quote + "  " + shareUrl1)
        )}`;
        window.location.href = sharelink;
      } else {
        handleNativeShare();
        console.log("Handling native share...");
      }
    } catch (error) {
      console.error("Error handling share:", error);
      handleNativeShare();
    }
  };

  return (
    <div
      onClick={(e) => {
        handleShare(e);
      }}
    >
      {children}
    </div>
  );
};

export default NativeShare;
